'use es6';

import { SET_IS_DRAGGING } from 'simple-menus-core/actions/ActionTypes';
import { combineReducers } from 'redux';
function isDragging(state = false, action) {
  switch (action.type) {
    case SET_IS_DRAGGING:
      {
        return action.isDragging;
      }
    default:
      {
        return state;
      }
  }
}
export default combineReducers({
  isDragging
});